import React, { memo } from "react"

import classNames from "classnames"

import { Hotkey } from "./StreamerHotkeys"

interface Props {
  hotkeys: string[]
  selectedIndex: number[]
  selectedHotkey: Hotkey | undefined
  handleSelectedIndex: Function
  handleSelectedHotkey: Function
}

function HotkeyList({
  hotkeys,
  selectedIndex,
  handleSelectedIndex,
  selectedHotkey,
  handleSelectedHotkey,
}: Props) {
  return (
    <div className="tableB top">
      <table className="list">
        <colgroup>
          <col width="50" />
          <col width="48" />
          <col width="*" />
        </colgroup>
        <thead>
          <tr>
            <th className="checkB">
              <a
                href="#!"
                className={classNames({
                  on: hotkeys.length && hotkeys.length === selectedIndex.length,
                })}
                onClick={(e) => {
                  e.preventDefault()

                  if (hotkeys.length === selectedIndex.length)
                    return handleSelectedIndex([])

                  handleSelectedIndex(
                    Array.from(new Set(Array(hotkeys.length).keys())),
                  )
                }}
              >
                선택
              </a>
            </th>
            <th className="pd0">단축키</th>
            <th>내용</th>
          </tr>
        </thead>
        <tbody>
          {hotkeys.map((hotkey, index) => (
            <tr
              key={index}
              onClick={() => {
                handleSelectedHotkey({ key: hotkey, index: index })
              }}
            >
              <td
                className="checkB"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()

                  selectedIndex.includes(index)
                    ? handleSelectedIndex(
                        selectedIndex.filter(
                          (selectedIndex) => selectedIndex !== index,
                        ),
                      )
                    : handleSelectedIndex([...selectedIndex, index])
                }}
              >
                <a
                  href="#!"
                  className={classNames({
                    on: selectedIndex.includes(index),
                  })}
                >
                  선택
                </a>
              </td>
              <td className="btn">
                <a href="#!" title={`F${index + 1}`}>
                  {`F${index + 1}`}
                </a>
              </td>
              <td
                className={classNames("txt", {
                  selected: selectedHotkey?.key === hotkey,
                })}
              >
                {hotkey}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
export default memo(HotkeyList)
